import { EnumCommodity } from '../../../api'
import {
  apiDeleteFlexibility,
  fetchFlexibilities
} from '../../../api/Argentia/endpoints/flexibilities/flexibility.api'
import { FlexibilitiesModel } from '../../../api/Argentia/endpoints/flexibilities/model/flexibilities'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../../model/serviceResponse'
import { getActiveBalanceZone, getActiveCompany } from '../../../redux'

export const fetchFlexibilitiesListItems = async (
  commodity: EnumCommodity,
  calculationType?: number,
  settlementGroupCode?: string,
  contractCode?: string
): Promise<ServiceResponse<FlexibilitiesModel[] | undefined>> => {
  return await fetchFlexibilities({
    commodity,
    calculationType,
    settlementGroupCode,
    contractCode,
    balanceZone: getActiveBalanceZone()?.id!,
    company: getActiveCompany()?.id!
  })
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteFlexibility = async (id: number): Promise<ServiceResponse<any>> => {
  return await apiDeleteFlexibility(id)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
